/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsClapperboardOpen: {
  name: 'clapperboard-open';
  data: string;
} = {
  name: 'clapperboard-open',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.786 1.245a2 2 0 0 1 2.395 1.56l.608 3.039a2 2 0 0 1-1.528 2.345L12.11 10H21a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11c0-.08.01-.159.028-.234a1.998 1.998 0 0 1-.209-.572l-.607-3.038A2 2 0 0 1 2.739 4.81l16.047-3.566ZM5.742 6.192l-2.57.571.608 3.039 1.298-.289.664-3.32Zm2.134-.474L7.212 9.04l2.889-.642.664-3.32-2.889.641Zm7.248 1.563-2.889.642.665-3.321 2.888-.642-.664 3.321Zm2.135-.474 2.569-.57-.608-3.04-1.297.289-.664 3.321ZM4 12v8h16v-8H4Z" fill="currentColor"/></svg>`,
};
